export default __webpack_public_path__ + "static/media/21_avocado.b53492f5.png";